import React from 'react';
import { Logo } from './Logo';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/sharework-logo1web.png';

class LoginHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <Navbar fixed="top">
                    <div className="header_area" style={{ height: '56px' }}>
                        <div className="container">
                            <div className="row">
                                <div style={{ width: '6%' }}></div>
                                <div className="" style={{ width: '25%' }}>
                                    <Link to={"/"}><img className="logo_img_res" alt="Company Logo" src={logo} /></Link>
                                </div>
                                <div style={{ width: '6%' }}></div>
                                <div style={{ width: '60%' }}></div>
                            </div>
                        </div>
                    </div>
                </Navbar>
            );
        }
        //for Desktop view
        if (isDesktop) {
            return (
                <Navbar fixed="top">
                    <div className="header_area" style={{ height: '65px' }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-2 ">
                                    <Logo />
                                </div>
                                <div className="col-md-2"></div>
                                <div className="col-md-4"> </div>
                                <div className="col-md-4"></div>
                            </div>
                        </div>
                    </div>
                </Navbar>
            );
        }
    }
}

export { LoginHeader };